import React, { Component } from 'react';
import { ButtonGroup, ToggleButton, Table } from 'react-bootstrap';

const CONSTANT = {
    SHOW_ALL: 'Show All',
    SHOW_LESS: 'Show Less',
    SHOW_ALL_VAR: 'primary',
    SHOW_LESS_VAR: 'secondary',
    SORT_2_WORST: 'Sort Best to Worst',
    SORT_2_BEST: 'Sort Worst to Best',
    SORT_2_WORST_VAR: 'success',
    SORT_2_BEST_VAR: 'danger',
}

class HandStrengthTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shouldShowAll: false,
            showToggleText: CONSTANT.SHOW_ALL,
            showToggleVariant: CONSTANT.SHOW_ALL_VAR,
            isBestToWorst: true,
            sortText: CONSTANT.SORT_2_BEST,
            sortVariant: CONSTANT.SORT_2_BEST_VAR,
            tData: [],
            displayedData: []
        }
    }

    filterDisplayedData = (rawData, shouldShowAll) => {
        if(shouldShowAll) {
            return rawData
        } else {
            return rawData.slice(0, 5)
        }
    }

    handleShowToggle = (e) => {
        let nextShouldShowAll = !this.state.shouldShowAll

        this.setState({
            shouldShowAll: nextShouldShowAll,
        })
    }

    handleSortToggle = (e) => {
        let nextSortText = null
        let nextSortVariant = null

        if(this.state.isBestToWorst) {
            nextSortText = CONSTANT.SORT_2_WORST
            nextSortVariant = CONSTANT.SORT_2_WORST_VAR
        } else {
            nextSortText = CONSTANT.SORT_2_BEST
            nextSortVariant = CONSTANT.SORT_2_BEST_VAR
        }

        let nextTData = this.state.tData.reverse()

        this.setState({
            isBestToWorst: !this.state.isBestToWorst,
            tData: nextTData,
            displayedData: this.filterDisplayedData(nextTData, this.state.shouldShowAll),
            sortText: nextSortText,
            sortVariant: nextSortVariant
        })
    }

    componentDidUpdate (prevProps, prevState) {
        if(this.props.handRankData !== prevProps.handRankData) {
            this.setState({
                tData: this.props.handRankData,
                displayedData: this.filterDisplayedData(this.props.handRankData, this.state.shouldShowAll)
            })
        }

        if(this.state.shouldShowAll !== prevState.shouldShowAll) {
            let nextShowToggleText = null
            let nextShowToggleVariant = null

            if(this.state.shouldShowAll) {
                nextShowToggleText = CONSTANT.SHOW_LESS
                nextShowToggleVariant = CONSTANT.SHOW_LESS_VAR
            } else {
                nextShowToggleText = CONSTANT.SHOW_ALL
                nextShowToggleVariant = CONSTANT.SHOW_ALL_VAR
            }

            this.setState({
                displayedData: this.filterDisplayedData(this.state.tData, this.state.shouldShowAll),
                showToggleText: nextShowToggleText,
                showToggleVariant: nextShowToggleVariant
            })
        }
    }

    render() {
        return (
            <div>
                <div className="text-center mt-4 mb-4">
                    <ButtonGroup toggle>
                        <ToggleButton className='mr-3'
                            checked={ this.state.shouldShowAll } 
                            variant={ this.state.showToggleVariant }
                            onChange={this.handleShowToggle}
                            type="checkbox">
                                { this.state.showToggleText }
                        </ToggleButton>
                    </ButtonGroup>
                    <ButtonGroup toggle>
                        <ToggleButton className='mr-3' 
                            variant={ this.state.sortVariant }
                            checked={ !this.state.isBestToWorst } 
                            onChange={ this.handleSortToggle }
                            type="checkbox">
                                { this.state.sortText }
                        </ToggleButton>
                    </ButtonGroup>
                </div>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Rank</th>
                            <th>Hand Type</th>
                            <th>6p. win odds</th>
                            <th>9p. win odds</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.displayedData.map(row => (
                            <tr key={row.rank}>
                                <td>{row.rank}</td>
                                <td>{row.hand}</td>
                                <td>{row.odds_6p + "%"}</td>
                                <td>{row.odds_9p + "%"}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        )
    }
}

export default HandStrengthTable;